import { useEffect, useState } from "react";

const gridSystem = {
  xs: 0,
  sm: 414,
  md: 834,
  lg: 1024,
  xl: 1900,
};

const getScreenSize = () => {
  const width = window.innerWidth;

  if (width >= gridSystem.xl) return "xl";
  if (width >= gridSystem.lg) return "lg";
  if (width >= gridSystem.md) return "md";
  if (width >= gridSystem.sm) return "sm";

  return "xs";
};

/**
 * useScreenSize
 * @returns Object that's contain screenSize xs | sm | md | lg | xl
 */
const useScreenSize = () => {
  const [screenSize, setScreenSize] = useState(getScreenSize());
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  const handleWindowSizeChange = () => {
    setScreenSize(getScreenSize());
    setScreenWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);

    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  });

  return { screenSize, screenWidth };
};

export default useScreenSize;
